export default "__VITE_PUBLIC_ASSET__08ed8c79__"